import React, { Suspense, useState, useEffect, useRef } from "react";
import Pagination from 'components/Common/newPagination';
import Drawer from 'react-modern-drawer';
import gridTemplateService from "./gridTemplateService";
import { CommonUtilities } from "commonUtils";
import commonServices from "components/Common/commonServices";

export default function ContactAssetListingBox(param: any) {
    console.log(param)

    let [contractAssetRow, setcontractAssetRow] = useState(0);
    let [splitsListingData, setSplitListingData] = useState<any>([]);

    console.log(param)

    var payload = { type: 'kontactAsset', pageNumber: 1, pageSize: 10, Assettype: 'Assets', contactCode: param?.code?.kontactCode }
    const splitsListing = () => {

        gridTemplateService.SplitsListing(payload).then((res: any) => {
            splitsListingData = CommonUtilities.relativeDataRemapping(res.data, res.headers.original)
            setSplitListingData(splitsListingData)
            contractAssetRow = res.totalRows
            setcontractAssetRow(contractAssetRow)
        })
    }

    useEffect(() => {

        splitsListing();

    }, [param.contactAssetOpen]);

    const closAssetSplit = () => {
        param.closContactAsset()
    }

    const exportKontactAssetsListing = () => {
        var payload = {
            type: "kontactAsset",
            pageNumber: 1,
            pageSize: 10,
            Assettype: "Assets",
            contactCode: param?.code?.kontactCode,
            exportType: param?.code?.kontactCode + "_AssetExport"
        }

        commonServices.excelGenericExport(payload)
    }

    const paginationContractAsset = (e: any) => {
        payload.pageNumber = e.pageNumber;
        payload.pageSize = e.pageSize;

        splitsListing();
    }

    return (
        <Drawer open={param.contactAssetOpen} onClose={closAssetSplit} direction='right' className='react-drawer full-height-vh allowHscroll allowVscroll ' size={1200}>

            <div className="ws-7 box pull-right ">

                <div className="ws-12">

                    <div className="pr ws-12">

                        <div className="form-horizontal bg-white ws-12 box ">

                            <div className="box-header-main well">
                                <h2 className="ws-10">Contact Asset Listing <span className="text-m ">{contractAssetRow} record(s) found</span></h2>
                            </div>

                            <div className="ws-12 pm pts">
                                <fieldset className="scheduler-border p0 m0">
                                    <legend className="scheduler-border"> <h2>  <i className="fa fa-sticky-note-o"></i> Contact Info  </h2>  </legend>

                                    <div className="ws-12">

                                        <div className="ws-4">
                                            <div className="form-format">
                                                <label className="control-label ws-4 text-right pr">  Contact Code :  </label>
                                                <div className="label-entries ws-8 ">  {param?.code?.kontactCode}  </div>
                                            </div>
                                        </div>

                                        <div className="ws-4">
                                            <div className="form-format">
                                                <label className="control-label ws-4 text-right pr">  Contact Name :  </label>
                                                <div className="label-entries ws-8 "> {param?.code?.kontactDisplay} </div>
                                            </div>
                                        </div>

                                        <div className="ws-4">
                                            <div className="form-format">
                                                <label className="control-label ws-4 text-right pr"> Email :  </label>
                                                <div className="label-entries ws-8 ">{param?.code?.emailAdd1}</div>
                                            </div>
                                        </div>
                                    </div>

                                </fieldset>
                            </div>

                            <div className="ws-12 mt pm">

                                <div className="box-header well">
                                    <h2 className="ws-6 "> {contractAssetRow} record(s) found </h2>
                                    <button title="Refresh File Details" className="icon-btn delete pull-right" onClick={splitsListing}><i className="icon-reload"></i></button>
                                    <button title="Export" className="icon-btn primary pull-right" onClick={exportKontactAssetsListing}><i className="icon-download1"></i> </button>
                                </div>

                                {contractAssetRow > 0 && <table className="table">
                                    <thead>
                                        <tr>

                                            <th>Artist</th>
                                            <th>Asset Name</th>
                                            <th>Asset Type</th>
                                            <th>Artist Type</th>

                                        </tr>
                                    </thead>
                                    <tbody>
                                        {splitsListingData?.map((val: any) => {
                                            return (
                                                <tr>
                                                    <td> <span title={val?.artistName} >{val?.artistName} ({val?.artistCode}) </span> </td>
                                                    <td> <span title={val?.assetName} >{val?.assetName} ({val?.assetCode}) </span> </td>
                                                    <td> <span title={val?.assetType} >{val?.assetType}</span> </td>
                                                    <td> <span title={val?.artistType} >{val?.artistType} </span> </td>
                                                </tr>
                                            )
                                        })}
                                    </tbody>
                                </table>}

                                {contractAssetRow > 10 && <div className="clearfix">
                                    {
                                        (() => {
                                            if (contractAssetRow && contractAssetRow > 10) {
                                                return <Pagination onPageChange={paginationContractAsset} totalRow={contractAssetRow} />
                                            }
                                        })()
                                    }

                                </div>}

                            </div>

                            {contractAssetRow == 0 && <div className="pLarge mbl ws-12"> <div className="alert">No results found for these criterias </div>  </div>}

                        </div>
                    </div>

                    <div className="box-footer pull-right">
                        <button className="btn icon-btn delete" onClick={closAssetSplit}> Close </button>
                    </div>
                </div>

            </div>

        </Drawer >
    )
}